document.addEventListener("DOMContentLoaded", () => {
	// Check if the GF with ID 2 exists
	const formWrapper = document.querySelector("#gform_wrapper_2:not(.popupForm)");
	if (!formWrapper) {
		console.error("The gravity form for secured resource downloads");
		return;
	}
	formWrapper.classList.toggle("popupForm", true);

	let dialogResetTimeout: ReturnType<typeof setTimeout>|undefined = undefined;

	document.getElementById("popupOverlay")?.addEventListener("click", closeOrResetPopup);

	const backup = formWrapper.cloneNode(true);
	initFormWrapper(formWrapper);

	// Add event listeners to secured resource links
	for (const securedResourceLink of document.querySelectorAll(".wp-block-plaudit-secure-resource a")) {
		securedResourceLink.addEventListener("click", secureResourceLinkClickHandler);
	}

	function closeOrResetPopup() {
		if (dialogResetTimeout) {
			const confirmation = document.getElementById("gform_confirmation_wrapper_2");
			if (confirmation) {
				resetPopup(confirmation);
				return;
			}
		}
		setPopupState(false);
	}
	function resetPopup(confirmation: Element) {
		if (dialogResetTimeout !== undefined) {
			clearTimeout(dialogResetTimeout);
			dialogResetTimeout = undefined;
		}
		setPopupState(false);
		const newFormWrapper = backup.cloneNode(true);
		if (newFormWrapper instanceof Element) {
			initFormWrapper(newFormWrapper);
			const friendlyCaptchaWrapper = newFormWrapper.querySelector(".ginput_container_frcaptcha");
			if (friendlyCaptchaWrapper) {
				reinitializeFriendlyCaptcha(friendlyCaptchaWrapper);
			}
			confirmation.parentElement!.replaceChild(newFormWrapper, confirmation);
		}
	}

	// Intercept Gravity Forms confirmation
	jQuery(document).on("gform_confirmation_loaded", (event, formId) => {
		if (formId === 2) { // Replace with your form ID
			const confirmation = document.getElementById("gform_confirmation_wrapper_2");
			if (confirmation) {
				confirmation.classList.toggle("popupForm", true); // We reuse the popupForm class here to mark the confirmation as being for by a popup form
				dialogResetTimeout = setTimeout(() => resetPopup(confirmation), 3000);
			}
		}
	});
});

function secureResourceLinkClickHandler(event: Event) {
	event.preventDefault();
	if (event.target instanceof Element) {
		// Update the dynamic message
		updateMessage(event.target.getAttribute("title"));

		const href = event.target.getAttribute("href");
		const securedResourceURLField = document.querySelector<HTMLInputElement>("#input_2_8");
		if (href && securedResourceURLField) {
			securedResourceURLField.value = href; // Assign the href to the field
		}
		// Show the popup
		setPopupState(true);
	}
}

// Function to update the dynamic message
function updateMessage(title: string|null): void {
	document.getElementById("gform_message")!.innerHTML = title
		? `Thank you for requesting a copy of our <span class='label'>${title}</span>.`
		: "Thank you for requesting a copy of this document.";
}

function initFormWrapper(formWrapper: Element) {
	// Create a container for the dynamic message
	const messageContainer = document.createElement("p");
	messageContainer.id = "gform_message";

	// Find the heading and insert the message container below it
	const heading = formWrapper.querySelector(".gform_heading");
	if (heading) {
		heading.insertAdjacentElement("afterend", messageContainer);
	} else {
		// Fall back on inserting the message container before the form if the heading cannot be found
		formWrapper.querySelector("form")!.insertAdjacentElement("beforebegin", messageContainer);
	}

	// Add a close button to the form
	const closeButton = document.createElement("button");
	closeButton.id = "popupCloseButton";
	formWrapper.appendChild(closeButton);
	closeButton.addEventListener("click", () => setPopupState(false));
}

function setPopupState(shown: boolean) {
	document.getElementById("popupOverlay")?.classList.toggle("popupOverlayActive", shown);
	const formWrapper = document.getElementById("gform_wrapper_2");
	if (formWrapper) {
		formWrapper.style.display = shown ? "block" : "none";
	}
}

function reinitializeFriendlyCaptcha(friendlyCaptchaWrapper: Element) {
	const friendlyCaptchaRoot = friendlyCaptchaWrapper.querySelector("[data-sitekey]");
	if (friendlyCaptchaRoot) {
		const siteKey = friendlyCaptchaRoot.getAttribute("data-sitekey")!; // This is guaranteed to be present by how we get friendlyCaptchaRoot
		const lang = friendlyCaptchaRoot.getAttribute("data-lang");
		const newFriendlyCaptchaRoot = document.createElement("div");
		newFriendlyCaptchaRoot.classList.add("frc-captcha");
		newFriendlyCaptchaRoot.setAttribute("data-sitekey", siteKey);
		if (lang) {
			newFriendlyCaptchaRoot.setAttribute("data-lang", lang);
		}
		friendlyCaptchaWrapper.replaceChild(newFriendlyCaptchaRoot, friendlyCaptchaRoot);
	}
}
